import { Injectable } from "@angular/core";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { DateTime } from "luxon";

@Injectable()
export class CustomDateAdapter {
    fromModel(value: string): NgbDateStruct | null {
        if (!value) return null

        var dateTime = DateTime.fromISO(value);
        if(dateTime && dateTime.isValid) {
            let date = { year: dateTime.year, month: dateTime.month, day: dateTime.day } as NgbDateStruct;
            return date;
        } 
                
        return null;
    }

    toModel(date: NgbDateStruct): string | null {
        if(!date) {
            return null;
        }

        var dateTime = DateTime.local(date.year, date.month, date.day);
        var result = dateTime.toFormat('yyyy-MM-dd');
        return result;
    }
}
